"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdRequestProxy = exports.getEndpoint = exports.getProxyHost = exports.PROXY_PRODUCTION_HOST = exports.PROXY_STAGING_HOST = exports.PROXY_DEVELOPMENT_HOST = exports.PROXY_LOCAL_HOST = void 0;
const types_1 = require("../tracking/types");
const types_2 = require("../types");
exports.PROXY_LOCAL_HOST = 'http://localhost:9292';
exports.PROXY_DEVELOPMENT_HOST = 'https://lebowski.wetransferalpha.net';
exports.PROXY_STAGING_HOST = 'https://lebowski.wetransferbeta.net';
exports.PROXY_PRODUCTION_HOST = 'https://lebowski.wetransfer.com';
const getProxyHost = (environmentName) => {
    const envToProxyUrlMap = {
        [types_2.EnvironmentName.Local]: exports.PROXY_LOCAL_HOST,
        [types_2.EnvironmentName.Development]: exports.PROXY_DEVELOPMENT_HOST,
        [types_2.EnvironmentName.Staging]: exports.PROXY_STAGING_HOST,
        [types_2.EnvironmentName.Production]: exports.PROXY_PRODUCTION_HOST,
    };
    const url = envToProxyUrlMap[environmentName];
    if (!url) {
        throw new Error(`No proxy url found for environment ${environmentName}`);
    }
    return url;
};
exports.getProxyHost = getProxyHost;
const getEndpoint = ({ product, demoAdvertId, }) => {
    if (demoAdvertId) {
        return `${exports.AdRequestProxy.endpoints['demo']}/${demoAdvertId}`;
    }
    if (product === types_1.AdtechProduct.WebMobile) {
        return exports.AdRequestProxy.endpoints['mobileWeb'];
    }
    return exports.AdRequestProxy.endpoints['web'];
};
exports.getEndpoint = getEndpoint;
exports.AdRequestProxy = {
    endpoints: {
        mobileWeb: '/v1/mobile/web',
        decisionApi: '/v1',
        web: '/v1/desktop',
        demo: '/v1/demo',
    },
};
//# sourceMappingURL=ad-request.config.js.map